import { openPopupHelper } from 'reactApp/modules/popup/popup.helpers';
import { popupNames } from 'reactApp/modules/popup/popup.types';

import type { PublicPasswordTariffModalProps } from './PublicPasswordTariffModal.types';

export const renderPublicPasswordTariffModal = (data?: PublicPasswordTariffModalProps) =>
    openPopupHelper({ popupName: popupNames.PUBLIC_PASSWORD_TARIFF_MOBILE, data });
